import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    ActivitySessionsQuery,
    ActivitySessionsQueryVariables,
} from "./__graphql-types__/ActivitySessionsQuery.ts";

const SKILL_LEVELS_FRAGMENT = gql`
    fragment ActivitySessionSkillLevelsV1 on SkillLevelChange {
        id
        before
        after
    }
`;

const ACTIVITY_SESSION_FRAGMENT = gql`
    fragment ActivitySessionV1 on ActivitySession {
        id
        title
        subtitle
        activityKind {
            id
        }
        durationMinutes
        eventTimestamp
        skillType
    }
`;

export const ACTIVITY_SESSIONS_QUERY: GqlOperation<
    ActivitySessionsQuery,
    ActivitySessionsQueryVariables
> = gqlOp(gql`
    query ActivitySessionsQuery(
        $studentKaid: String!
        $endDate: Date
        $startDate: Date
        $courseType: String
        $activityKind: String
        $after: ID
        $pageSize: Int
    ) {
        user(kaid: $studentKaid) {
            id
            activityLog(
                endDate: $endDate
                startDate: $startDate
                courseType: $courseType
                activityKind: $activityKind
            ) {
                time {
                    exerciseMinutes
                    totalMinutes
                }
                activitySessions(pageSize: $pageSize, after: $after) {
                    sessions {
                        ...ActivitySessionV1
                        ... on MasteryActivitySession {
                            correctCount
                            problemCount
                            skillLevels {
                                ...ActivitySessionSkillLevelsV1
                                exercise {
                                    id
                                    translatedTitle
                                }
                            }
                            task {
                                id
                                isRestarted
                            }
                        }
                    }
                    pageInfo {
                        nextCursor
                    }
                }
            }
        }
    }

    ${ACTIVITY_SESSION_FRAGMENT}
    ${SKILL_LEVELS_FRAGMENT}
`);
